module.exports = __webpack_public_path__ + "static/media/pix4.045e2b33.jpg";